<script setup lang="ts">
const props = withDefaults(defineProps<{
  isOpen: boolean
  isLoading?: boolean
  title?: string
  description?: string
  confirmText?: string
  cancelText?: string
}>(), {
  isLoading: false,
  title: 'Descartar alteração?',
  description: 'Ao sair da edição de equipamentos, as alterações feitas serão descartadas.',
  confirmText: 'Descartar',
  cancelText: 'Voltar à edição',
})

const emit = defineEmits<{
  close: []
  confirm: []
  cancel: []
}>()
</script>

<template>
  <SolModal
    id="cancel-edit-modal"
    :is-open="isOpen"
    :title="props.title"
    :action-secondary-text="props.cancelText"
    :size="{ desktop: 'medium', mobile: 'bottom-sheet' }"
    @close="emit('close')"
    @action:secondary="emit('cancel')"
  >
    <p>{{ props.description }}</p>

    <template #action-primary>
      <SolButton
        id="cancel-edit-confirm-button"
        variant="primary"
        size="medium"
        :loading="props.isLoading"
        :disabled="props.isLoading"
        @click="emit('confirm')"
      >
        {{ props.confirmText }}
      </SolButton>
    </template>
  </SolModal>
</template>
